import { Box, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { colors } from 'src/global/styles/colors';
import { ProjectInputs } from 'src/global/types/project.type';
import { useDeployment } from 'src/provider/DeploymentProvider';

import { AdminDateTimePicker } from '../AdminDateTimePicker';
import { StepAccordion } from '../StepAccordion';
import { WhitelistPopupNotification } from './WhiteListPopupNotification';

const NodeSaleSettings = ({ isDetail = false }: { isDetail?: boolean }) => {
  const { hasDeployed } = useDeployment();
  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectInputs>();
  return (
    <StepAccordion isError={!!errors.setting} index={3} title='Drop Settings' open={false}>
      <Typography color={'white'} fontWeight={500} fontSize={'16px'} variant='h6' paddingBottom={3}>
        Start Date & Time
      </Typography>
      <Box width={'100%'}>
        <Typography color={colors.neutral300} fontWeight={400} fontSize={'14px'} paddingBottom={1}>
          Start Date & Time
        </Typography>
        <Controller
          control={control}
          name='setting.startedAt'
          render={({ field }) => {
            return (
              <AdminDateTimePicker
                readOnly={isDetail || hasDeployed}
                isError={!!errors?.setting?.startedAt}
                errorMsg={errors?.setting?.startedAt?.message}
                value={new Date(field.value)}
                inputRef={field.ref}
                onChange={date => {
                  field.onChange(date);
                }}
              />
            );
          }}
        />
      </Box>
      <WhitelistPopupNotification isDisabled={isDetail} />
    </StepAccordion>
  );
};

export default NodeSaleSettings;
